import axios from '@/libs/api.request';
import search from '@/libs/search';
import axiosRequest from 'axios';
import { getAreaList } from '@/api/modules/system-management/area-management';
import { webGetAllRegion } from '@/api/modules/system-management/region-management';
import { getWarehouseList } from '@/api/modules/warehouse-management/warehouse';

export const getSeedFarmList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmList',
        data: data,
        method: 'post'
    });
};

export const getBugProductCodeListBySeedFarmUuid = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getBugProductCodeListBySeedFarmUuid',
        data: data,
        method: 'post'
    });
};
export const getSeedFarmOffAccArtList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmOffAccArtList',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmAllList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmAllList',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarm = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarm',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmDept = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmDept',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmOffAccArt = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmOffAccArt',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmByLogin = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmByLogin',
        data: data,
        method: 'post'
    });
};

export const deletSeedFarmeOffAccArt = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/deleteSeedFarmOffAccArt',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmDepositDueRate = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmDepositDueRate',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmLinkPreSalePlans = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmLinkPreSalePlans',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmDepositDueRateByFarm = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmDepositDueRateByFarm',
        data: data,
        method: 'post'
    });
};

export const pageInit4SeedFarmEdit = () => {
    const areaSearch = search.getSearchParams({ closeAllConditions: true });

    return axiosRequest.all([
        getAreaList(areaSearch),
        getWarehouseList(areaSearch)
    ]).then(axiosRequest.spread(function (area, warehouse) {
        if (area.code === 0 && warehouse.code === 0) {
            return {
                code: 0,
                message: '',
                data: {
                    area: area.data,
                    warehouse: warehouse.data
                }
            };
        }
    }));
};

export const getStoreKeeperForSeedFarm = () => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmAvailableStorekeeperList',
        data: {},
        method: 'post'
    });
};

export const updateSeedFarmStoreKeeper = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/updateSeedFarmStoreKeeper',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmPreSaleSetting = () => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmPreSaleSetting',
        data: {},
        method: 'post'
    });
};

export const saveSeedFarmPreSaleSetting = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmPreSaleSetting',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmToDistributionStationCost = () => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmToDistributionStationCost',
        data: {},
        method: 'post'
    });
};

export const saveSeedFarmToDistributionStationCost = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmToDistributionStationCost',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmCurSaleToDistributionStation = () => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmCurSaleToDistributionStation',
        data: {},
        method: 'post'
    });
};

export const getSeedFarmDepositStationSettingList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmDepositStationSettingList',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmCurSaleToDistributionStation = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmCurSaleToDistributionStation',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmDepositStationSetting = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmDepositStationSetting',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmBlockDist = () => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmBlockDist',
        data: {},
        method: 'post'
    });
};

export const saveSeedFarmBlockDist = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmBlockDist',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmWeekBinding = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmWeekBinding',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmCode = () => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmCode',
        data: {},
        method: 'post'
    });
};

export const getSeedFarmToDistributionStationUnit = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmToDistributionStationUnit',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmToDistributionStationUnit = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/saveSeedFarmToDistributionStationUnit',
        data: data,
        method: 'post'
    });
};

export const getPromotionList = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/getPromotionList',
        data: data,
        method: 'post'
    });
};

export const getUserPromotionList = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/getUserPromotionList',
        data: data,
        method: 'post'
    });
};

export const savePromotion = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/savePromotion',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmPromotion = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/saveSeedFarmPromotion',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmPromotionList = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/getSeedFarmPromotionList',
        data: data,
        method: 'post'
    });
};

export const saveSeedFarmManualPromotion = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/saveSeedFarmManualPromotion',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmManualPromotionList = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/getSeedFarmManualPromotionList',
        data: data,
        method: 'post'
    });
};

export const batchAddPromotion = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/batchAddPromotion',
        data: data,
        method: 'post'
    });
};

export const batchActivePromotion = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/batchActivePromotion',
        data: data,
        method: 'post'
    });
};

export const batchPublicPromotion = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/batchPublicPromotion',
        data: data,
        method: 'post'
    });
};

export const getSeedFarmProductList = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/getSeedFarmProductList',
        data: data,
        method: 'post'
    });
};

export const getAllUserList = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/getAllUserList',
        data: data,
        method: 'post'
    });
};

export const getAllTypeUserList = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/getAllTypeUserList',
        data: data,
        method: 'post'
    });
};

export const getUserListByKey = data => {
    return axios.request({
        url: 'api/saleManagement/saleHelpPutToCart/getUserListByKey',
        data: data,
        method: 'post'
    });
};

export const computePromotion = data => {
    return axios.request({
        url: 'api/preSaleManagement/promotion/computePromotion',
        data: data,
        method: 'post'
    });
};


export const saveProductAgent = data => {
    return axios.request({
        url: 'api/productManagement/productAgent/saveProductAgent',
        data: data,
        method: 'post'
    });
};

export const batchAddProductAgent = data => {
    return axios.request({
        url: 'api/productManagement/productAgent/batchAddProductAgent',
        data: data,
        method: 'post'
    });
};

export const getProductAgentList = data => {
    return axios.request({
        url: 'api/productManagement/productAgent/getProductAgentList',
        data: data,
        method: 'post'
    });
};

export const importAgentSaleProduct = data => {
    return axios.request({
        url: 'api/productManagement/productAgent/importAgentSaleProduct',
        data: data,
        method: 'post'
    });
};


export const updateSeedFarmsDepositDueRate = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/UpdateSeedFarmsDepositDueRate',
        data: data,
        method: 'post'
    });
};

export const updateSeedFarmsAutoCheckIntention = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/UpdateSeedFarmsAutoCheckIntention',
        data: data,
        method: 'post'
    });
};

export const getYSDeptList = data => {
    return axios.request({
        url: 'api/YSManagement/getYSDeptList',
        data: data,
        method: 'post'
    });
};

export const getRelateList = async () => {
    try {
        // 使用 axios.all() 并确保 webGetAllRegion 和 getYSDeptList 返回的都是 Promise
        const [regionRes, deptRes] = await axiosRequest.all([
            webGetAllRegion(),  // 如果需要传递空对象，可以根据实际情况调整
            getYSDeptList()
        ]);

        // 确保 regionRes 和 deptRes 存在并且返回成功
        if (!regionRes || regionRes.code !== 0 || !deptRes || deptRes.code !== 0) {
            throw new Error('API请求失败');
        }

        const { allRegions } = regionRes.data;

        return {
            code: 0,
            message: '',
            data: {
                allRegions,
                provinceOptions: allRegions.filter(r => r.regionType === 1),
                cityOptions: [],
                distOptions: [],
                YSDeptOptions: deptRes.data.deptList
            }
        };
    }
    catch (error) {
        console.error('获取关联选项失败:', error);
        console.error('error.message:', error.message);
        return {
            code: -1,
            message: error.message,
            data: null
        };
    }
};
export const getSeedFarmAcceptCusMgrInfo = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getSeedFarmAcceptCusMgrInfo',
        data: data,
        method: 'post'
    });
};

export const getUserSeedFarmList = data => {
    return axios.request({
        url: 'api/systemManagement/seedFarmManagement/getUserSeedFarmList',
        data: data,
        method: 'post'
    });
};



